module.exports = __webpack_public_path__ + "img/rexiaotuijian.1479017d.jpg";